<template>
    <div v-if="breadList && breadList.length" class="bread-x">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item v-for="(item, index) in breadList" :key="index" :to="{ path: item.link }">
                {{item.name}}
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>
<script>
    const _data = [
        {name: '系统管理', link: ''},
        {name: '列表页', link: '/system/log'},
        {name: '详情页', link: ''}
    ];
    export default{
        data(){
            return {}
        },
        computed:{
            breadList(){
                return this.$root.breadList || _data
            }
        },
        mounted(){
        }
    }
</script>
<style type="text/scss" lang="scss" scoped>
    .bread-x{
        height: 34px;
        padding: 10px 20px;
        box-sizing: border-box;
        background-color: #fff;
        margin-bottom: 20px;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
    }
</style>